import logo from "../../assets/images/transparentlogo.png";
import facebooklogo from "../../assets/images/minifacebooklogo.svg";
import twitterlogo from "../../assets/images/minitwitterlogo.svg";
import instalogo from "../../assets/images/miniinstalogo.svg";
import linkedlogo from "../../assets/images/minilinkedinlogo.svg";
import gmblogo from "../../assets/images/gmblogo.png";
import { Link } from "react-router-dom";
import ROUTES from "../../routes";
import { useNavigate,useLocation } from 'react-router-dom';
import { COPYRIGHT_TEXT } from "../../Utils/constants";

const Footer = () => {

  const navigate = useNavigate();
  const location = useLocation();
  
  
  const scrollToProductSection = () => {
    if (location.pathname === '/') {
      const element = document.getElementById('product-section');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate('/', { state: { scrollToSection: 'product-section' } });
    }
  };

  return (
    <>
      <footer className="footer pb-0">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <img src={logo} alt="SkyAzul company logo" />
              <p className="footer-company-desc mb-0">
                SkyAzúl Equipment Solutions is a proven leader in the sales and
                service of monitoring systems for construction and mining
                equipment.
              </p>
            </div>
            <div className="col-md-5">
              <label className="c__label">QUICK LINKS</label>
              <ul className="list-unstyled footer-link-list d-flex flex-wrap">
                <li>
                <Link
                      to="/"
                      onClick={scrollToProductSection}
                      >
                    Product
                </Link>
                </li>
                <li>
                  <Link to={ROUTES.ABOUT_US}>About Us</Link>
                </li>
                <li>
                  <Link to={ROUTES.REQUEST_QUOTE}>Request A Quote</Link>
                </li>
                <li>
                  <Link to={ROUTES.RESOURCES}>Resources</Link>
                </li>
                <li>
                  <Link to={ROUTES.PRODUCT_CATEGORY}>On-Line</Link>
                </li>
                <li>
                  <Link to={ROUTES.TUTORIALS}>Store Tutorials</Link>
                </li>
                <li>
                  <Link to={ROUTES.BLOGS}>Blogs</Link>
                </li>
                <li>
                  <Link to={ROUTES.CONTACT}>Contact Us</Link>
                </li>
                <li>
                  <Link to={ROUTES.PRIVACY_POLICY}>Privacy & Policy</Link>
                </li>
              </ul>
            </div>
            <div className="col-md-3">
              <label className="c__label">CONTACT US</label>
              <address>
                16 Walnut Street,Middletown ,<br /> Maryland 21769 <br />
                (301) 371-6126 <br />
                info@skyazul.com
              </address>
            </div>
          </div>
        </div>
        <div className="sub-footer">
          <div className="container d-flex">
            <p className="footer-company-desc mb-0 mt-0">
              {COPYRIGHT_TEXT}
            </p>
            <ul className="list-unstyled d-flex align-items-center ms-auto mb-0">
              <li>
                <a
                  href="https://www.facebook.com/SkyAzulEquipmentSolutions/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={facebooklogo} alt="Facebook - SkyAzul" />
                </a>
              </li>
              <li className="ms-2">
                <a
                  href="https://x.com/Skyazul_Service"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={twitterlogo} alt="Twitter - SkyAzul" />
                </a>
              </li>
              <li className="ms-2">
              <a
                  href="https://www.instagram.com/skyazul_iservice/"
                  target="_blank"
                  rel="noreferrer"
                >
                <img src={instalogo} alt="Instagram - SkyAzul" />
                </a>
              </li>
              <li className="ms-2">
              <a
                  href="https://www.linkedin.com/company/skyaz%C3%BAl-equipment-solutions/posts/"
                  target="_blank"
                  rel="noreferrer"
                >
                <img src={linkedlogo} alt="LinkedIn - SkyAzul" />
                </a>
              </li>
              <li className="ms-2">
              <a
                  href="https://maps.app.goo.gl/7YLbUKF4T7bsQitY7"
                  target="_blank"
                  rel="noreferrer"
                >
                <img src={gmblogo} alt="Google Maps - SkyAzul office location" style={{ width: "34px", height: "34px" }} />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
